/**
 * @typedef {import('vue').ComponentOptions<Vue>} VueComponent
 */

/** @type {VueComponent} */
import Headroom from 'headroom.js';
import Vue from 'vue';

export default {
    props: {
        section: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            allNavigationItems: [],
            allNavItems: null,
            activeLink: '',
        };
    },

    components: {
        'cta-builder-component': () => import('./async-cta-builder-component'),
    },

    mounted() {
        // grab an element
        const myElement = document.querySelector('.mobile-cta-bar');
        // construct an instance of Headroom, passing the element
        const headroom = new Headroom(myElement);
        // initialise
        headroom.init();

        this.allNavigationItems = document.querySelectorAll('[data-page-nav]');
        this.allNavItems = this.initPageNav();
        this.activeLink = window.location.href;
        this.handleUrlChange();
    },

    watch: {
        '$root.showMenu': function (visible) {
            this.hideCtaBar(visible);
        },

        '$root.showCountries': function (visible) {
            this.hideCtaBar(visible);
        },
    },

    methods: {
        hideCtaBar(visible) {
            const modelCtaBar = document.getElementById('model-cta-bar');
            const body = document.body;

            if (!modelCtaBar) return;

            if (visible) {
                modelCtaBar.style.display = 'none';
                body.style.overflow = 'hidden';
                return;
            }

            modelCtaBar.style.display = 'block';
            body.style.overflow = 'unset';
        },

        handleUrlChange() {
            window.addEventListener('hashchange', (e) => {
                this.activeLink = e.newURL;
            });
        },

        isLinkActive(link) {
            const decodedVal = window.decodeURI(this.activeLink);
            return decodedVal.includes(link)
                ? 'model-new-cta-bar__link--active'
                : '';
        },

        initPageNav() {
            if (!this.allNavigationItems || !this.allNavigationItems.length) {
                return;
            }

            return this.allNavigationItems
                .filter((element) => element.getAttribute('id').length)
                .map((element) => ({
                    title: element.getAttribute('data-page-nav'),
                    anchor: `#${element.getAttribute('id')}`,
                    iconUrl: element.getAttribute('data-navigation-icon') || '',
                }));
        },
    },
};
